import zipcodeApi from '~/clientApis/zipcodeApi';
import { getStore } from '~/mobx/AppStore';

const getZipcode = async () => {
    const { zipcodeStore, regionStore } = getStore();

    const zipcode = await zipcodeApi.getZipcode(regionStore.selectedRegionId);
    zipcodeStore.setSelectedZipcode(zipcode.value);
};

export default getZipcode;
